module.exports = __webpack_public_path__ + "img/promotion_01.9fd71091.png";